/** @format */

/* eslint-disable */
import React from 'react'
import EnumsServerCombo from '../../../../../../../Components/ComboBox/EnumsServerCombo'
import Loader from '../../../../../../../Components/Loaders/Loader'
import ModalTemplate from '../../../../../../../Components/ModalTemplate/ModalTemplate'
import ReversalBatchEntries from '../../../../../../../Components/ReUsables/BatchEntries/ReversalBatchEntries/ReversalBatchEntries'
import localize from '../../../../../../../Global/Localize'
import { formatDate } from '../../../../../../../Helpers/formatters'

const VerifyReversalModal = ({
  reversal,
  handleClose,
  setReversal,
  mode,
  clearValidation,
  globalValidationErrors,
  handleVerifyReversal,
  isBusy,
}) => {
  return (
    <ModalTemplate
      modalTitle="reversal"
      cancelText="close"
      modalMode={mode}
      handleClose={handleClose}
      modalClassName="modal-xl"
      handleAction={handleVerifyReversal}
      disableClose={isBusy}
      disableCreate={isBusy}
      footerChildren={
        <>
          <div className="d-flex align-items-center justify-content-end gap-4">
            <div
              className="d-flex align-items-center with-validation"
              validation-message={globalValidationErrors['Remarks']?.message}
            >
              <label className="text-capitalize col-4">
                {localize('remarks')}
              </label>
              <input
                disabled={isBusy}
                type="text"
                className="form-control"
                value={reversal?.verificationRemarks || ''}
                onChange={e => {
                  clearValidation('Remarks')
                  setReversal({
                    ...reversal,
                    verificationRemarks: e.target.value,
                  })
                }}
              />
            </div>
            <div className="d-flex align-items-center gap-2">
              <label className="text-capitalize">
                {localize('authOption')}
              </label>
              <EnumsServerCombo
                disabled={isBusy}
                customContainerStyle={{ width: '100%' }}
                enumsKey="BatchAuthOption"
                value={reversal?.batchAuthOption}
                onChange={e => {
                  setReversal({
                    ...reversal,
                    batchAuthOption: e.value,
                  })
                }}
                sort
              />
            </div>
          </div>
        </>
      }
    >
      {isBusy ? (
        <Loader />
      ) : (
        <>
          <div className="row g-3">
            <div className="col-md-4">
              <div className="d-flex align-items-center">
                <label className="text-capitalize col-4">
                  {localize('batchNumber')}
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={reversal?.paddedBatchNumber}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex align-items-center">
                <label className="text-capitalize col-4">
                  {localize('valueDate')}
                </label>
                <input
                  type="text"
                  className="form-control ms-1"
                  value={formatDate(reversal?.valueDate, true)}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex align-items-center">
                <label className="text-capitalize col-4">
                  {localize('remarks')}
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={reversal?.remarks}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="d-flex align-items-center">
                <label className="text-capitalize col-4">
                  {localize('createdBy')}
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={reversal?.createdBy}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="d-flex align-items-center">
                <label className="text-capitalize col-2">
                  {localize('createdDate')}
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={formatDate(reversal?.createdDate)}
                  disabled
                />
              </div>
            </div>
          </div>
          <div
            className="p-2 mt-4"
            style={{
              border: 'solid 1px #0000001f',
              borderRadius: 10,
              position: 'relative',
            }}
          >
            <div
              className="bg-white px-2  row text-capitalize"
              style={{
                position: 'relative',
                top: -20,
                left: 30,
                maxWidth: 'fit-content',
              }}
            >
              {localize('batchEntries')}
            </div>
            <div className="row mt-4">
              <ReversalBatchEntries
                showSelect={false}
                hiddenColumns={[0]}
                journalReversalBatchId={reversal?.id}
              />
            </div>
          </div>
        </>
      )}
    </ModalTemplate>
  )
}

export default VerifyReversalModal
